import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-496bca80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire__footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        disabled: !_ctx.hasPrevious,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPrevious && _ctx.onClickPrevious(...args)))
      }, "Pergunta anterior", 8, _hoisted_3),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickFinish && _ctx.onClickFinish(...args)))
      }, "Finalizar exercício"),
      _createElementVNode("button", {
        disabled: !_ctx.hasNext,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickNext && _ctx.onClickNext(...args)))
      }, "Próxima pergunta", 8, _hoisted_4)
    ])
  ]))
}